﻿import {
  messageTexts,
  setBankIdQrImage,
  getBankidLink,
  getAppBankidLink,
  handleDonePollStatusResponse,
  getIOSBankidLink,
} from "./bankid-utils";
import { isMobileBrowser, isIos, isFirefoxOnAndroid } from "./utils";
import {
  successState,
  loginMethod,
  pushActivation,
  pushLogin,
} from "./datalayer-helper";
import { setErrorMessage } from "./error-handling";
import {
  setDefaultActivationState,
  setDefaultLoginState,
  setBankIdQrState,
  setBankIdSameDeviceState,
  setFailureToActivateState,
  setFailedPollStatusState,
} from "./state-management";

(function ($) {
  "use strict";

  var socket;
  var shouldRequestNewQrCode = true;
  var isActivation = $("#authenticationReason").val();
  var returnUrl = $("#returnUrl").val();
  var authenticationUrl = $("#authenticationUrl").val();
  var token = $('input[name="__RequestVerificationToken"]').first().val();
  var orderRef = null;
  var pollTimeoutId;

  var activationData;

  var scheme = document.location.protocol === "https:" ? "wss" : "ws";
  var port = document.location.port ? ":" + document.location.port : "";
  var websocketUrl =
    scheme + "://" + document.location.hostname + port + "/bank-id/startqr";

  function startQrAuthentication() {
    shouldRequestNewQrCode = true;
    socket = new WebSocket(websocketUrl);
    socket.onmessage = function (event) {
      if (typeof event.data === "string" || event.data instanceof String) {
        orderRef = event.data;
        pollStatus(true, isActivation);
      } else {
        setBankIdQrImage(event.data);
      }
    };
    $("#bank-id-qr-status p").text("");
    setBankIdQrState();

    socket.onopen = function (event) {
      requestNewQrCode(socket);
    };
  }

  function requestNewQrCode(socket) {
    if (!shouldRequestNewQrCode) {
      if (socket && socket.readyState == WebSocket.OPEN) {
        socket.close(1000, "Closing from client");
      }
      return;
    }
    if (!socket || socket.readyState !== WebSocket.OPEN) {
      console.log("socket not connected in requesting");
    }
    socket.send("");
    setTimeout(() => {
      requestNewQrCode(socket);
    }, 1000);
  }

  function startSameDeviceAuthentication() {
    $.ajax({
      url: "/bank-id/start",
      method: "post",
    }).done(function (res) {
      setBankIdSameDeviceState();
      orderRef = res.orderRef;
      pollStatus(false, isActivation, true);
      $("#bank-id-not-open-btn").attr(
        "href",
        getAppBankidLink(res.autoStartToken)
      );

			if (isFirefoxOnAndroid()) {
				window.open(getBankidLink(res.autoStartToken), "_self");
			}
			else {
				window.open(getBankidLink(res.autoStartToken), "_blank");
			}
    });
  }

  function pollStatus(isQr, action, isSameDevice) {
    if (!orderRef) {
      return;
    }
    pollTimeoutId = setTimeout(function () {
      $.ajax({
        url: `/bank-id/${authenticationUrl}?orderRef=${orderRef}`,
        method: "post",
        headers: {
          RequestVerificationToken: token,
        },
      })
        .done((res) => {
          var result = handleDonePollStatusResponse(res, isQr, isSameDevice);
          if (res.status === "pending") {
            shouldRequestNewQrCode = result;
            pollStatus(isQr, action, isSameDevice);
          } else if (res.status === "complete") {
            shouldRequestNewQrCode = false;
            onComplete(res);
          } else if (res.status === "failed") {
            setFailedPollStatusState();
            clearTimeout(pollTimeoutId);
            pollTimeoutId = null;
            orderRef = null;
            shouldRequestNewQrCode = false;
          }
        })
        .fail(function (res) {
          orderRef = null;
          setFailedPollStatusState();
          $(".bank-id-status").hide();
          setErrorMessage(res.responseText);
          pushLogin(successState.Unsuccessful, loginMethod.BankID);
        });
    }, 2000);
  }

  function onComplete(res) {
    clearTimeout(pollTimeoutId);
    pollTimeoutId = null;
    orderRef = null;

    if (res.redirectToActivationView) {
      activationData = res.activationData;
      $("#spinner").addClass("hidden");
      $("#autoActivationView").show();
      $("#bankid-authentication-view").hide();
      $("#authentication-title").text("Aktivering av BankID för inloggning");
      return;
    }

    if (res.nextUrl && res.nextUrl.includes("activate")) {
      $(".bank-id-status p").text("Aktiverar bankid");
      $(".bank-id-cancel-button").hide();
      activateBankId(res.activationData, res.nextUrl);
    } else {
      $("#bank-id-not-open-btn").hide();
      $(".bank-id-status p").text("Inloggning pågår");
      pushLogin(successState.Successful, loginMethod.BankID);
      window.location.href = decodeURIComponent(returnUrl);
    }
  }

  $("#bankid-activate").on("click", function () {
    $("#spinner").removeClass("hidden");
    $("#autoActivationView").hide();
    $("#bank-id-activation-status").show();
    $.ajax({
      url: "/bank-id/activate/auto",
      method: "post",
      headers: {
        RequestVerificationToken: token,
      },
      data: {
        request: activationData,
      },
    })
      .done(function (res) {
        activateBankId(res.activationData, res.nextUrl);
      })
      .fail(function (res) {
        $("#spinner").addClass("hidden");
        $("#bank-id-activation-failure-btn").show();
        $("#bank-id-activation-status").hide();
        setErrorMessage();
      });
  });

  var activationTimer = 0;
  function activateBankId(activationData, statusUrl) {
    $.ajax({
      url: statusUrl,
      method: "post",
      headers: {
        RequestVerificationToken: token,
      },
      dataType: "text",
      data: {
        ReturnUrl: returnUrl,
        OrderRef: orderRef,
        ActivationData: activationData,
      },
      statusCode: {
        200: function (res) {
          pushActivation(successState.Successful);
          window.location.href = res;
        },
        204: function () {
          handleActivate204Response(activationData, statusUrl);
        },
      },
    }).fail(function () {
      pushActivation(successState.Unsuccessful);
      setFailureToActivateState();
    });
  }

  function handleActivate204Response(activationData, statusUrl) {
    activationTimer++;
    if (activationTimer > 30) {
      $(".bank-id-status p").text(
        "Det verkar ta lite tid men vi jobbar på att aktivera din bankidinloggning"
      );
    }
    if (activationTimer < 60) {
      setTimeout(() => {
        activateBankId(activationData, statusUrl);
      }, 3000);
    } else {
      setFailureToActivateState();
    }
  }

  async function cancelTransaction() {
    if (!pollTimeoutId) {
      return;
    }
    clearTimeout(pollTimeoutId);
    pollTimeoutId = null;
    $("#spinner").addClass("hidden");
    $("#bank-id-qr-image").hide();
    $("#bank-id-qr-try-again").show();

    shouldRequestNewQrCode = false;

    if (orderRef) {
      await $.ajax({
        url: `/bank-id/cancel?orderRef=${orderRef}`,
        method: "post",
      }).done(function () {
        orderRef = null;
      });
    }
  }

  $("#mobile-bank-id").on("click", function () {
    if (isMobileBrowser()) {
      $("#bank-id-other-device").show();
    }
  });

  $("#bank-id-cancel-qr-button").on("click", function () {
    cancelTransaction();
    if (isActivation) {
      setDefaultActivationState();
    } else {
      setDefaultLoginState();
    }
  });

  $("#bank-id-other-device").on("click", function () {
    cancelTransaction().then(() => {
      startQrAuthentication();
    });
  });

  $("#bank-id-qr-try-again").on("click", function () {
    startQrAuthentication();
  });

  function initiateBankIdStartIOS() {
    $.ajax({
      url: "/bank-id/start",
      method: "post",
    }).done(function (res) {
      setBankIdSameDeviceState();
      orderRef = res.orderRef;
      var iOSBankIdLink = getIOSBankidLink(res.autoStartToken);
      document
        .getElementById("bank-id-not-open-btn")
        .setAttribute("href", iOSBankIdLink);
      window.open(iOSBankIdLink, "_self");
    });
  }

	function isAuthenticationPage() {
		return document.location.pathname === "/bank-id/authentication";
	}

  function handleAuthenticationStart() {
    if (!isMobileBrowser()) {
      startQrAuthentication();
      return;
    }

    if (!isIos(navigator.userAgent)) {
      startSameDeviceAuthentication();
      return;
    }

    if (isIos(navigator.userAgent)) {
      initiateBankIdStartIOS();
    }
  }

  $(document).ready(function () {
		if (!isAuthenticationPage()) return;
    handleAuthenticationStart();
  });

  document.addEventListener("visibilitychange", () => {
		if (!isAuthenticationPage()) return;
    if (document.visibilityState === "visible") {
			if (isMobileBrowser() && isIos(navigator.userAgent)) {
        pollStatus(false, isActivation, true);
    }
	}
});
})(global.jQuery);
